module.exports = __webpack_public_path__ + "static/media/1.ac85e382.jpg";